
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import {Button} from 'reactstrap';

const saleContextUtil = require('../../../utils/saleContextUtil');
const translator = require('../../../../../utils/translator/translator');
const saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');

class ExitToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {};
    }

    render()
    {
        let saleContext = this.props.saleContext;
        return (<Fragment>
                    <Button className='btn-action' disabled={!saleCommonUtility.canExitSale(saleContext)} 
                            style={{minHeight:'8vh', minWidth:"33.33%", borderRadius: 0}}
                            onClick={()=>
                            {
                                saleContextUtil.publishAndCloseSale(saleContext)
                            }}>
                            {translator.getLabel("exit")}
                        </Button>
                </Fragment>)
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(ExitToolbarButton)
